// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.medispace-container {
    display: flex;
    color: #00666F;
}

.medispace-panel {
    min-height: 100vh
}

.medispace-left-panel {
    width: 40%;
    padding: 0 3%;
    background-color: #FCFCFC;
}

.medispace-right-panel {
    width: 60%;
    background-color: #D5EBED;
}

.medispace-logos-line {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 30px;
    margin-top: 60px;
    margin-bottom: 30px;
}

.medispace-logos-line div {
    width: 40%;
    display: flex;
    align-items: center;
    margin-right: 20px;
}

.medispace-logos-line img {
    margin: auto;
    width: 100%;
}

.msp-domus-logo {
    width: 80% !important;
    margin-bottom: 10px !important;
}

.medispace-empty-div {
    height: 140px;
}

.medispace-h1 {
    font-weight: 600;
    color: #007E94;
}

.medispace-p {
    font-weight: 500;
    margin: 30px 0px;
}

.medispace-center-img {
    margin-top: 23%;
    margin-left: auto;
    margin-right: auto;
    width: 300px;
    height: 300px;
    border-radius: 200px;
    background-color: #F7F7F7;
}

.medispace-img {
    width: 240px;
    margin-top: 30px;
    margin-left: 30px;
}

.medispace-insert {
    background-color: #FFF;
    box-shadow: 5px 20px 25px #AAA;
    padding: 15px;
    border-radius: 15px;
    margin-top: 30px;
}

.medispace-insert-mail {
    width: 80%;
}

.medispace-insert-qrcode {
    width: 60%;
    text-align: center;
}

.medispace-label {
    font-weight: 600;
    font-size: 12px;
}

.medispace-input-container {
    margin: 15px;
}

.medispace-input {
    border-radius: 10px;
    border: 1px solid #ccc;
    color: #00666F;
    padding: 2px 15px;
    width: 100%;
    font-size: 14px;
    margin: 5px 0px;
}

.medispace-button {
    border-radius: 15px;
    border: 0px;
    padding: 13px 25px;
    background-color: #1DADB5;
    color: #fff;
    font-weight: 600;
}

.medispace-session-buttons {
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.medispace-delete-session {
    margin-right: 20px;
    background-color: white;
    color: red;
    border: solid 2px;
}

.medispace-span {
    font-size: 14px;
    font-weight: 600;
    color: #007E94;
}

@media screen and (max-width: 1000px) {
    .medispace-right-panel {
        display: none;
    }

    .medispace-left-panel {
        width: 100%;
    }

    .medispace-session-buttons {
        position: initial;
        bottom: initial;
        right: initial;
        background-color: initial;
        box-shadow: initial;
        padding: initial;
        border-radius: initial;
        margin-bottom: 30px;
    }

    .medispace-session-buttons button {
        width: 47%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Medispace.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".medispace-container {\n    display: flex;\n    color: #00666F;\n}\n\n.medispace-panel {\n    min-height: 100vh\n}\n\n.medispace-left-panel {\n    width: 40%;\n    padding: 0 3%;\n    background-color: #FCFCFC;\n}\n\n.medispace-right-panel {\n    width: 60%;\n    background-color: #D5EBED;\n}\n\n.medispace-logos-line {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    height: 30px;\n    margin-top: 60px;\n    margin-bottom: 30px;\n}\n\n.medispace-logos-line div {\n    width: 40%;\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n}\n\n.medispace-logos-line img {\n    margin: auto;\n    width: 100%;\n}\n\n.msp-domus-logo {\n    width: 80% !important;\n    margin-bottom: 10px !important;\n}\n\n.medispace-empty-div {\n    height: 140px;\n}\n\n.medispace-h1 {\n    font-weight: 600;\n    color: #007E94;\n}\n\n.medispace-p {\n    font-weight: 500;\n    margin: 30px 0px;\n}\n\n.medispace-center-img {\n    margin-top: 23%;\n    margin-left: auto;\n    margin-right: auto;\n    width: 300px;\n    height: 300px;\n    border-radius: 200px;\n    background-color: #F7F7F7;\n}\n\n.medispace-img {\n    width: 240px;\n    margin-top: 30px;\n    margin-left: 30px;\n}\n\n.medispace-insert {\n    background-color: #FFF;\n    box-shadow: 5px 20px 25px #AAA;\n    padding: 15px;\n    border-radius: 15px;\n    margin-top: 30px;\n}\n\n.medispace-insert-mail {\n    width: 80%;\n}\n\n.medispace-insert-qrcode {\n    width: 60%;\n    text-align: center;\n}\n\n.medispace-label {\n    font-weight: 600;\n    font-size: 12px;\n}\n\n.medispace-input-container {\n    margin: 15px;\n}\n\n.medispace-input {\n    border-radius: 10px;\n    border: 1px solid #ccc;\n    color: #00666F;\n    padding: 2px 15px;\n    width: 100%;\n    font-size: 14px;\n    margin: 5px 0px;\n}\n\n.medispace-button {\n    border-radius: 15px;\n    border: 0px;\n    padding: 13px 25px;\n    background-color: #1DADB5;\n    color: #fff;\n    font-weight: 600;\n}\n\n.medispace-session-buttons {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n}\n\n.medispace-delete-session {\n    margin-right: 20px;\n    background-color: white;\n    color: red;\n    border: solid 2px;\n}\n\n.medispace-span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #007E94;\n}\n\n@media screen and (max-width: 1000px) {\n    .medispace-right-panel {\n        display: none;\n    }\n\n    .medispace-left-panel {\n        width: 100%;\n    }\n\n    .medispace-session-buttons {\n        position: initial;\n        bottom: initial;\n        right: initial;\n        background-color: initial;\n        box-shadow: initial;\n        padding: initial;\n        border-radius: initial;\n        margin-bottom: 30px;\n    }\n\n    .medispace-session-buttons button {\n        width: 47%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
